namespace _Ext {
    export interface ReplaceRowResponse extends Serenity.ServiceResponse {
    }
}
